module.exports = __webpack_public_path__ + "media/images/emoji-world-a80950a9104e8c9c8971af9a3f394874.png";